import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/daisy';

import { ExamFormVariant } from './ExamForm';

type ExamFormControlsProps = {
  variant: ExamFormVariant;
  isLoading?: boolean;
  onCancel?: () => void;
  hasChanges?: boolean;
};

export default function ExamFormControls({
  variant = 'default',
  isLoading,
  onCancel,
  hasChanges,
}: ExamFormControlsProps) {
  if (variant === 'inline')
    return <InlineControls isLoading={isLoading} onCancel={onCancel} />;
  return <DefaultControls isLoading={isLoading} hasChanges={hasChanges} />;
}

const InlineControls = ({
  isLoading,
  onCancel,
}: Pick<ExamFormControlsProps, 'isLoading' | 'onCancel'>) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.examForm.form',
  });

  return (
    <div className="flex justify-end gap-2">
      <Button
        type="button"
        className="grow bg-base-300"
        onClick={onCancel}
        disabled={isLoading}
      >
        {t('cancel')}
      </Button>
      <Button
        type="submit"
        color="secondary"
        className="grow"
        disabled={isLoading}
        loading={isLoading}
      >
        {t('save')}
      </Button>
    </div>
  );
};

const DefaultControls = ({
  isLoading,
  hasChanges,
}: Pick<ExamFormControlsProps, 'isLoading' | 'hasChanges'>) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.examForm.form',
  });
  return (
    <div className="flex justify-end">
      <Button
        type="submit"
        color="primary"
        className="px-16"
        disabled={isLoading || !hasChanges}
        loading={isLoading}
      >
        {t('save')}
      </Button>
    </div>
  );
};
